const HomebaseInstructions = () => (
    <div className="instructions">
        <h2>Instructions</h2>
        <p><b>Seasonal Tip:</b> This section keeps your informed with seasonal tips.</p>
        <p><b>Announcement:</b> Current announcements which include things like contests, upcoming changes to the application and things of that nature.</p>
        <p><b>Your Gardening Tasks:</b> This section contains your personalized scheduled tasks, answer the questions here to update your journal or use the Garden Journal tab if you prefer to update all tasks at once.</p>
        <p>        Tasks are scheduled from the beginning of the calendar year so you can start tracking crops you may have already started. </p>
        <p>        Keep in mind that germinating, thinning, protecting and harvesting tasks only appear once planting has been recorded.</p>
        <p><b>Share Your Garden:</b> Is an area to add social content.</p>
    </div>
);

export default HomebaseInstructions;
